import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { GeotabEulaService } from 'src/app/iframe-authentication/services/geotab-eula/geotab-eula.service';

@Injectable({
  providedIn: 'root',
})
export class GeotabEulaGuard implements CanActivate {
  constructor(private router: Router, private geotabEulaService: GeotabEulaService) {}

  canActivate(): Promise<boolean> {
    return new Promise((resolve) => {
      this.geotabEulaService.isEULAAccepted().subscribe((value) => {
        if (value) {
          resolve(true);
        } else {
          this.router.navigate(['geotab-eula']);
        }
      });
    });
  }
}
